<div class="app-shell">
  @if (maintenanceNotice()) {
    <div class="maintenance-notice" role="status" aria-live="polite" data-cy="maintenance-notice">
      <span class="rb-ic rb-ic-alert-warning maintenance-notice__icon" aria-hidden="true"></span>
      <span class="maintenance-notice__text">{{ maintenanceNotice() }}</span>
      <button
        type="button"
        class="maintenance-notice__close"
        aria-label="Close maintenance notice"
        title="Close maintenance notice"
        (click)="dismissMaintenanceNotice()"
      >
        <span class="rb-ic rb-ic-close" aria-hidden="true"></span>
      </button>
    </div>
  }

  <div class="container-fullbleed layout-main app-shell__content">
    <a class="position-absolute top-0 z-1" [routerLink]="'/'">
      <app-rb-live-clip></app-rb-live-clip>
    </a>

    <div class="position-absolute top-2 end-3 z-1 d-flex align-items-center">
      <app-app-selection></app-app-selection>
      <app-account></app-account>
    </div>

    <div class="position-relative h-100">
      <app-map></app-map>
      <router-outlet></router-outlet>
    </div>
  </div>

  <div class="supergraphic bar"></div>
</div>
<app-toasts></app-toasts>
<app-debug></app-debug>
